export type ProxyDelegateCallDto = {
  addresses: string[];
  signedDescriptor: string;
};
